/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : PRODUCT MANAGER CONTROLBAR : STYLES --------------- ++++++++++ */
export default theme => ({
  controlbar: {
    width: pxToEm(80),
    position: 'absolute',
    fontSize: pxToEm(12),
    background: '#FFF',
    boxShadow: '-1.74px 1.74px 3.47px 0px rgba(0, 0, 0, 0.08)',
    '&.BOTTOM_PLACEMENT': {
      width: '100%',
      '& > div': {
        flexFlow: 'row',
        gap: 0
      },
      '& .icons': {
        borderBottom: 0,
        borderRight: '1px solid',
        alignItems: 'center',
        justifyContent: 'center',
        flexFlow: 'row',
        padding: '6px 0',
        gap: '4px',
        '&:last-child': {
          borderRight: 0
        },
      },
      '&.LEFT_ALIGNMENT': {
        '& > div': {
          gap: 8
        },
        '& .icons': {
          justifyContent: 'flex-start',
          gap: '8px',
          padding: '6px'
        }
      },
      '&.RIGHT_ALIGNMENT': {
        '& > div': {
          gap: 8
        },
        '& .icons': {
          justifyContent: 'flex-end',
          gap: '8px',
          padding: '6px'
        }
      }
    },

    '& > div': {
      padding: pxToEm(12),
      '& > div': {
        paddingBottom: pxToEm(16),
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '&:first-child': {
          paddingTop: pxToEm(12)
        }
      }
    },
    '& .icons': {
      borderBottom: '1px solid',
      '& svg': {
        cursor: 'pointer'
      },
      '&:last-child': {
        borderBottom: 0
      }
    },
    '&.LEFT_EDGE_PLACEMENT': {
      borderTopRightRadius: pxToEm(24),
      borderBottomRightRadius: pxToEm(24)
    },
    '&.RIGHT_EDGE_PLACEMENT': {
      borderTopLeftRadius: pxToEm(24),
      borderBottomLeftRadius: pxToEm(24),
    }
  }
});
